var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8F63CE19-F194-4DE1-88DD-9414BFA75EED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.077,6.5 C22.629,6.5 23.077,6.948 23.077,7.5 L23.077,9.5 C23.077,10.052 22.629,10.5 22.077,10.5 L1,10.5 C0.447,10.5 -3.01980663e-14,10.052 -3.01980663e-14,9.5 L-3.01980663e-14,7.5 C-3.01980663e-14,6.948 0.447,6.5 1,6.5 L22.077,6.5 Z M29,0 C29.552,0 30,0.448 30,1 L30,3 C30,3.552 29.552,4 29,4 L1,4 C0.447,4 2.84217094e-14,3.552 2.84217094e-14,3 L2.84217094e-14,1 C2.84217094e-14,0.448 0.447,0 1,0 L29,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,12 C29.552,12 30,12.448 30,13 L30,15 C30,15.552 29.552,16 29,16 L1,16 C0.447,16 2.84217094e-14,15.552 2.84217094e-14,15 L2.84217094e-14,13 C2.84217094e-14,12.448 0.447,12 1,12 L29,12 Z M17.461,6 C18.014,6 18.461,6.448 18.461,7 L18.461,9 C18.461,9.552 18.014,10 17.461,10 L1,10 C0.447,10 -2.84217094e-14,9.552 -2.84217094e-14,9 L-2.84217094e-14,7 C-2.84217094e-14,6.448 0.447,6 1,6 L17.461,6 Z M17.461,0 C18.014,0 18.461,0.448 18.461,1 L18.461,3 C18.461,3.552 18.014,4 17.461,4 L1,4 C0.447,4 -2.84217094e-14,3.552 -2.84217094e-14,3 L-2.84217094e-14,1 C-2.84217094e-14,0.448 0.447,0 1,0 L17.461,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-67.000000, -424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(24.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Bar-Chart/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(5.000200, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000200, -6.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(5.000200, 19.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000200, -19.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.8e217bab9d9db77f7a10d89761d89336.svg";
export { ForwardRef as ReactComponent };